const routesConfig = [
  {
    path: "/dashboard",
    component: "Dashboard",
    roles: ["user", "admin"], // Доступ для всіх користувачів
  },
  {
    path: "/admin",
    component: "Admin",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/users",
    component: "adminUsers",
    roles: ["admin"], // Тільки для адміністраторів
  },

  {
    path: "/admin/upload-incomings",
    component: "AddIncomingTab",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/addnewuser",
    component: "AddNewUser",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/driver-raport",
    component: "adminDriverRaport",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/incoming",
    component: "AddIncomingTab",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/incoming-preview/:service",
    component: "IncomingPreview",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/add-freenow-info",
    component: "AddFreeNowInfo",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/add-freenow-info/:id",
    component: "AddFreeNowInfo",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/edit-freenow-info",
    component: "EditFreeNowInfo",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/freenow/records",
    component: "EditFreeNowInfo",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/driver-debts",
    component: "adminDriversDebts",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/driver-debts/:id",
    component: "DriverDebtDetails",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/driver-extra-funds",
    component: "DriverExtraFunds",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/edit-extra-funds",
    component: "DriverExtraFundsEdit",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/edit-extra-funds/:id",
    component: "DriverExtraFundsEdit",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/extra-funds-default-values",
    component: "ExtraFundsDefaultValues",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/cash-stats",
    component: "CashStats",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/cash-data",
    component: "CashStats",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/instructions",
    component: "Instructions",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/edit-source-data",
    component: "editSourceData",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/edit-source-data/:service",
    component: "editSourceData",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/weekly-stats",
    component: "weeklyStats",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/admin/week-statistics",
    component: "WeekStatistics",
    roles: ["admin"],
  },
  {
    path: "/admin/check-reports",
    component: "adminRaports",
    roles: ["admin"], // Тільки для адміністраторів
  },
  {
    path: "/settings",
    component: "UserSettings",
    roles: ["user", "admin"]
  },
  {
    path: "/admin/settings",
    component: "siteSettings",
    roles: ["admin"]
  },
  {
    path: "/user/dashboard",
    component: "UserDashboard",
    roles: ["admin", "user"]
  },
  {
    path: "/user/raport",
    component: "UserRaport",
    roles: ["admin", "user"]
  },
  {
    path: "/user/report/:id",
    component: "UserRaport",
    roles: ["admin", "user"]
  },
  {
    path: "/admin/messages",
    component: "AdminMessageForm",
    roles: ["admin"]
  },
  {
    path: "/admin/messages/all",
    component: "AdminMessagesList",
    roles: ["admin"]
  },
  {
    path: "/admin/reports-table",
    component: "AdminReportsTable",
    roles: ["admin"]
  },
  {
    path: "/admin/driver-report/:id",
    component: "AdminReportView",
    roles: ["admin"]
  },
  {
    path: "/admin/monthly-reports",
    component: "monthlyReports",
    roles: ["admin"]
  },
  {
    path: "/admin/generate-invoice",
    component: "generateInvoice",
    roles: ["admin"]
  },
  {
    path: "/admin/month-summary",
    component: "monthSummary",
    roles: ["admin"]
  },
  {
    path: "/admin/invoice-constructor",
    component: "invoiceConstructor",
    roles: ["admin"]
  },
  {
    path: "/admin/fleet",
    component: "FleetList",
    roles: ["admin"]
  },
  {
    path: "/admin/fleet/new",
    component: "FleetVehicleForm",
    roles: ["admin"]
  },
  {
    path: "/admin/fleet/:id",
    component: "FleetVehicleForm",
    roles: ["admin"]
  },
  {
    path: "/admin/import-data",
    component: "DataImport",
    roles: ["admin"]
  },
  {
    path: "/admin/ksef",
    component: "KsefPage",
    roles: ["admin"]
  },
  {
    path: "/admin/driver-invoices",
    component: "DriverInvoicesPage",
    roles: ["admin"]
  },
  {
    path: "/admin/driver-invoices/new",
    component: "DriverInvoiceUploadPage",
    roles: ["admin"]
  },

  {
    path: "/user/messages",
    component: "UserMessages",
    roles: ["user"]
  },
  {
    path: "/user/upload-invoice",
    component: "DriverUploadInvoicePage",
    roles: ["user"]
  },
  {
    path: "/user/my-invoices",
    component: "DriverMyInvoicesPage",
    roles: ["user"]
  },





];

export default routesConfig;
